import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileTree = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M840-356H715v-154H305v-93h130v-277H120v277h125v247H120v276h315v-276H305v-94h350v94H525v276h315zM180-820h195zm405 524h195zm-405 0h195zm195 0v156H180v-156zm405 0v156H585v-156zM375-820v157H180v-157z" })
});
export default SvgFileTree;
